import { render } from "./UploadCover.vue?vue&type=template&id=9f1cde28"
import script from "./UploadCover.vue?vue&type=script&lang=js"
export * from "./UploadCover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__